import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
export var BubbleBase = /*#__PURE__*/function () {
  function BubbleBase() {
    _classCallCheck(this, BubbleBase);
    this.distance = 200;
    this.duration = 0.4;
    this.mix = false;
  }
  _createClass(BubbleBase, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = data.distance;
      }
      if (data.duration !== undefined) {
        this.duration = data.duration;
      }
      if (data.mix !== undefined) {
        this.mix = data.mix;
      }
      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
      if (data.color !== undefined) {
        if (data.color instanceof Array) {
          this.color = data.color.map(function (s) {
            return OptionsColor.create(undefined, s);
          });
        } else {
          if (this.color instanceof Array) {
            this.color = new OptionsColor();
          }
          this.color = OptionsColor.create(this.color, data.color);
        }
      }
      if (data.size !== undefined) {
        this.size = data.size;
      }
    }
  }]);
  return BubbleBase;
}();